import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(root)/getting-started/page.tsx");
